import React from "react";
import { useSelector } from "react-redux";
import LocalNavSoftLink from "../LocalNavSoftLink";

export default function ResourceLinks() {
    const pathname = useSelector(state => state.router.location.pathname);
    const pwExpired = useSelector(state => state.session.pwExpired);

    if (pwExpired) return null;

    const isResourceCenterActive = () =>
        ["/help", "/partners", "/dataproviders", "/discover"].some(p => pathname.includes(p));

    return (
        <>
            <LocalNavSoftLink
                id="resource-center"
                key="resource-center"
                destination="/help"
                text="Resource Center"
                isActive={isResourceCenterActive}
                isCollapsed
                collapsedIcon="/Images/Icons/resources.png"
            />
            <LocalNavSoftLink
                id="ae-docs"
                key="ae-docs"
                destination="/wiki"
                text="Documentation"
                isCollapsed
                collapsedIcon="/Images/Icons/wiki.svg"
                openTab={true}
            />
        </>
    );
}
